import { message } from 'antd'
import Auth from '../../modules/Authentication'
import { useEffect, useState } from 'react'

export default function useFetchURL(
  url,
  dependencyArray = [],
  dontFetch = false,
  mapFunction,
  sendAuth = true,
  initData = []
) {
  const [data, setData] = useState(initData)
  const [fetching, setFetching] = useState(false)

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }

  const auth = new Auth()

  async function fetchURL() {
    if (!dontFetch) {
      setFetching(true)
      try {
        let response
        if (sendAuth) {
          headers['authorization'] = `Bearer ${auth.getAccessToken()}`
          response = await fetch(url, { headers })
        } else {
          response = await fetch(url)
        }

        const data = await response.json()

        if (mapFunction) setData(mapFunction(data))
        else setData(data)
      } catch (e) {
        console.error(e)
        message.error(e.errorMessage || 'Not Found')
      }
      setFetching(false)
    }
  }

  useEffect(() => {
    fetchURL()
    return () => {}
  }, dependencyArray)
  return { data, fetching, fetchURL, setData }
}
